import { useMemo, useState } from 'react';

import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { ICD10Code } from '../../../shared/types';

import { MedicineSelectorIcd10Code } from './medicineSelector.types';

type UseMedicineSelectorIdc10CodesStateReturn = {
   icd10Codes: MedicineSelectorIcd10Code[];
   selectedIcd10Codes: MedicineSelectorIcd10Code[];
   selectCode: (icd10Code: ICD10Code) => void;
   deselectCode: (icd10Code: ICD10Code) => void;
};

export const useMedicineSelectorIcdCodesState = (
   visitDiagnoses: VisitDiagnosis[]
): UseMedicineSelectorIdc10CodesStateReturn => {
   const [medicineSelectorIcd10Codes, setMedicineSelectorIcd10Codes] = useState<MedicineSelectorIcd10Code[]>(
      visitDiagnoses.map((diagnosis) => ({ ...diagnosis, selected: false }))
   );

   return useMemo(
      () => ({
         icd10Codes: medicineSelectorIcd10Codes,
         selectedIcd10Codes: medicineSelectorIcd10Codes.filter((currentCode) => currentCode.selected),
         selectCode: (icd10Code: ICD10Code) => {
            setMedicineSelectorIcd10Codes(
               medicineSelectorIcd10Codes.map((currentCode) => {
                  if (currentCode.icd10Code === icd10Code) {
                     return {
                        ...currentCode,
                        selected: true,
                     };
                  }
                  return currentCode;
               })
            );
         },
         deselectCode: (icd10Code: ICD10Code) => {
            setMedicineSelectorIcd10Codes(
               medicineSelectorIcd10Codes.map((currentCode) => {
                  if (currentCode.icd10Code === icd10Code) {
                     return {
                        ...currentCode,
                        selected: false,
                     };
                  }
                  return currentCode;
               })
            );
         },
      }),
      [medicineSelectorIcd10Codes]
   );
};
